<template>
	<div class="ui large modal">
		<div class="header">
			{{ $t('modals.availableproducts.header') }}
		</div>
		<div class="content">
			<div class="ui two column stackable divided grid">
				<div class="row">
					<div class="four wide column">
						<div class="ui vertical inverted fluid menu">
							<a class="item" v-for="category in categories.data" :key="category.id" :class="{ 'blue active' : category.id === activeCategory }" @click="activeCategory = category.id">
								{{ category.name }}
							</a>
						</div>
						<div class="ui pagination menu" v-if="categories.last_page <= 3 && categories.last_page > 1">
							<a class="item" v-for="amount in categories.last_page" :key="amount" :class="{ 'active' : amount === categoryPage }" @click="categoryPage = amount">
								{{ amount }}
							</a>
						</div>
						<div class="ui pagination menu" v-else-if="categories.last_page > 3">
							<a class="item icon" v-if="categoryPage !== 1" @click="categoryPage--">
								<i class="chevron left icon"/>
							</a>
							<a class="item">
								{{ categoryPage }}
							</a>
							<a class="item icon" v-if="categories.last_page !== categoryPage" @click="categoryPage++">
								<i class="chevron right icon"/>
							</a>
						</div>
					</div>
					<div class="twelve wide column" >
						<div class="ui three zw stackable cards" v-if="availableProducts.data.length > 0">
							<div class="product card" v-for="product in availableProducts.data" :key="product.id">
								<div class="content">
									<div class="header">{{ product.name }}</div>
								</div>
								<div class="content">
									<div class="description" v-html="product.intro"></div>
								</div>
                <div class="content" v-if="product.apply_storage_count && product.storage_count_current < 1">
                  <div class="not-available">{{ $t('modals.availableproducts.not_available') }}</div>
                </div>
                <div class="content" v-else-if="product.accessories.length > 0 && !checkAvailableAccessories(product.accessories)">
                  <div class="not-available">{{ $t('modals.available_accessories.not_available') }}</div>
                </div>
								<div class="ui bottom attached button" :class="{'disabled': (product.apply_storage_count && product.storage_count_current < 1) || (product.accessories.length > 0 && !checkAvailableAccessories(product.accessories))}" @click="selectProduct(product.id)">
									<i class="plus icon"/>
									{{ $t('modals.availableproducts.card.button') }}
								</div>
							</div>
						</div>

						<div class="ui centered aligned icon header" v-else>
							<i class="close icon"/>
							{{ $t('globals.validation.errors.nothing_found') }}
						</div>

						<div class="ui basic segment compact right floated">
							<div class="ui pagination menu" v-if="availableProducts.last_page > 1 && availableProducts.last_page < 5">
								<a class="item" v-for="amount in availableProducts.last_page" :key="amount" :class="{ 'active' : productsPage === amount }" @click="productsPage = amount">
									{{ amount }}
								</a>
							</div>
							<div class="ui pagination menu" v-else-if="availableProducts.last_page >= 5">
								<a class="item icon" v-if="productsPage !== 1" @click="productsPage--">
									<i class="chevron left icon"/>
								</a>
								<a class="item">
									{{ productsPage }}
								</a>
								<a class="item icon" v-if="availableProducts.last_page !== productsPage" @click="productsPage++">
									<i class="chevron right icon"/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="actions">
			<div class="ui red deny button">{{ $t('globals.buttons.cancel') }}</div>
			<div class="ui positive button">{{ $t('globals.buttons.done') }}</div>
		</div>
	</div>
</template>

<script>
	import first from 'lodash/first'
  import hopscotch from 'hopscotch'
  import findIndex from "lodash/findIndex";

	export default {
		name: 'AvailableProductsModal',

		props: {
			active: {
				required: true,
				type: Boolean,
				default: false
			},

			waitlist: {
				required: false,
				default: false,
				type: Boolean
			},

      intro: {
        required: false,
        default: false,
        type: Boolean
      },
		},

		data () {
			return {
				categories: {
					data: []
				},
				activeCategory: null,
				categoryPage: 1,

				availableProducts: {
					data: []
				},
				productsPage: 1,
				newSubscription: null,
				filter: this.waitlist ? 'waitlist' : 'subscription',
				url: this.waitlist ? 'waitlistsubscriptions' : 'subscriptions',

        tour: {
          id: 'available-products-tour',
          steps: [],
          nextOnTargetClick: false,
          showNextButton: true,
          i18n: {
            nextBtn: this.$t('globals.buttons.next')
          }
        },

				accessoryNotAvailable: ''
			}
		},

		watch: {
			active () {
				this.fetchCategories()
					.then(data => {
						// set active categories
						this.categories = data

						// set active category
						if (data.data.length > 0) {
							this.activeCategory = first(data.data).id

							this.fetchProducts(this.activeCategory)
								.then(Products => {
									this.availableProducts = Products

                  if (this.intro) {
                    console.log('Creating intro')
                    this.$nextTick(() => {
                      this.createIntro()
                        .then(tour => {
                          setTimeout(() => {
                            hopscotch.endTour([true])
                            hopscotch.startTour(tour, 0)
                          }, 300)
                        })
                    })
                  }
								}).catch()
						}

						// show modal when dom has loaded
						this.$nextTick(() => {
							$(this.$el).modal('refresh').modal('show')
						})
					})
			},

			categoryPage () {
				this.fetchCategories()
					.then(data => {
						// set active categories
						this.categories = data

						// set active category
						if (data.data.length > 0) {
							this.activeCategory = first(data.data).id

							this.fetchProducts(this.activeCategory)
								.then(Products => {
									this.availableProducts = Products
								}).catch()
						}
					})
			},

			productsPage () {
				this.fetchProducts(this.activeCategory)
					.then(Products => {
						this.availableProducts = Products
					}).catch()
			},

			activeCategory (categoryId) {
        this.fetchProducts(categoryId, true)
					.then(Products => {
            this.productsPage = 1
						this.availableProducts = Products
						$(window).trigger('resize')
					}).catch()
			},

			newSubscription (newSubscription) {
				this.$nextTick(() => {
					if (newSubscription !== null) {
            $(this.$el).modal('hide')
            this.$emit('close')
            this.$events.fire('OpenNewSubscription', newSubscription)
					}
				})
			},

			activeMerchant () {
				this.categoryPage = 1
			}
		},

		mounted () {
			this.$nextTick(function () {
				const _this = this
				$(this.$el).modal({
					observeChanges: true,
					detachable: true,
					closable: true,
					transition: 'fade',

					onVisible () {
						$(_this.$el).modal('refresh')
					},

          onHide () {
            if (_this.intro) {
              hopscotch.endTour([true])
            }
          }
				})
			})
		},

		methods: {
			fetchCategories () {
				return new Promise((resolve, reject) => {
					this.axios.get(`merchants/${this.activeMerchant.id}/categories`, {
						params: {
							perPage: 7,
							page: this.categoryPage,
              filter: this.filter
						}
					})
					.then(({data}) => {
						resolve(data)
					}).catch(error => {
						reject(error)
					})
				})
			},

			fetchProducts (categoryId, isNew = false) {
				return new Promise((resolve, reject) => {
					this.axios.get(`merchants/me/${this.activeMerchant.id}/products`, {
						params: {
							perPage: 15,
							page: isNew ? 1 : this.productsPage,
							filter: this.filter,
							category_id: categoryId
						}
					})
					.then(({data}) => {
						resolve(data)
					}).catch(error => {
						reject(error)
					})
				})
			},

			selectProduct (productId) {
        let data = {}

        if (this.intro) {
          data['intro'] = true
        }

				this.axios.post(`${this.url}/${productId}`, data)
				.then(({data}) => {
					this.fetchNewSubscription(data.id)
						.then(Subscription => {
							this.newSubscription = null
							this.newSubscription = Subscription

							this.$events.$emit('alert', {
								header: this.$t('modals.availableproducts.validation.success.new_product'),
								message: this.$t('modals.availableproducts.validation.success.follow_process'),
								type: 'success',
								closebutton: true,
								align: 'right'
							})
						}).catch()
				}).catch((error) => {
          if (error.response.data.message) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: error.response.data.message,
              type: 'error',
              closebutton: true,
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              closebutton: true,
              align: 'right'
            })
          }
				})
			},

			fetchNewSubscription (subscriptionId) {
				return new Promise((resolve, reject) => {
					if (subscriptionId) {
						this.axios.get(`${this.url}/${subscriptionId}`)
							.then(({data}) => {
								resolve(data)
							}, error => {
								reject(error)
							})
					} else {
						reject('Missing Subscription ID')
					}
				})
			},

			refreshSubscription (subscriptionId) {
				this.fetchNewSubscription(subscriptionId)
					.then(Subscription => {
						this.newSubscription.product.fields = Subscription.product.fields
						this.newSubscription.accessories = Subscription.accessories
						this.newSubscription.pricing_plans = Subscription.pricing_plans
					})
			},

      createIntro () {
        return new Promise((resolve, reject) => {
          this.tour.steps = []
          this.tour.steps.push(
            {
              title: this.$t('modals.availableproducts.intro.categories.title'),
              content: this.$t('modals.availableproducts.intro.categories.content'),
              target: '.ui.vertical.inverted.fluid.menu',
              placement: 'right',
              showNext: this.availableProducts.data.length > 0,
              delay: 300
            }
          )

          if (this.availableProducts.data.length > 0) {
            this.tour.steps.push(
              {
                title: this.$t('modals.availableproducts.intro.products.title'),
                content: this.$t('modals.availableproducts.intro.products.content'),
                target: '.ui.three.zw.stackable.cards',
                placement: 'top',
                showNext: false,
                delay: 300
              }
            )
          }

          resolve(this.tour)
        })
      },

      checkAvailableAccessories (accessories) {
        let isAvailable = true

        $.each(accessories, (index, accessory) => {
          if (accessory.mandatory && accessory.apply_storage_count && accessory.storage_count_current <= 0) {
            isAvailable = false
            return false
          }
        })

        return isAvailable
      }
		},

		computed: {
			activeMerchant () {
				return this.$store.getters.activeMerchant
			}
		}
	}
</script>

<style lang="scss" scoped>
	.product.card {
		.content {
			.header, .description {
				overflow: hidden;
				text-overflow: ellipsis;
			}
      .not-available {
        color: red;
      }
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/merchant/AvailableProductsModal.vue